import React from 'react';
import Helmet from 'react-helmet';
import { makePaginationUrl } from 'helpers/pagination';

interface CLPMetaTagsProps {
  currentPage: number;
  isIndexable: boolean;
  metaTitle: string;
  metaKeywords: string;
  metaDescription: string;
  canonicalUrl: string;
}

export function CLPMetatags(props: CLPMetaTagsProps): React.JSX.Element {
  const { currentPage, isIndexable, metaTitle, metaDescription, metaKeywords, canonicalUrl } = props;

  const helmetMetaTitle = { name: 'title', content: metaTitle };
  const helmetMetaDescription = { name: 'description', content: metaDescription };
  if (currentPage && currentPage >= 2) {
    helmetMetaTitle.content = `Page ${currentPage} - ${helmetMetaTitle.content}`;
    helmetMetaDescription.content = `Page ${currentPage} - ${helmetMetaDescription.content}`;
  }

  return (
    <Helmet
      meta={[
        helmetMetaTitle,
        helmetMetaDescription,
        { name: 'keywords', content: metaKeywords },
        { name: 'robots', content: isIndexable ? 'index,follow' : 'noindex' },
        { name: 'format-detection', content: 'telephone=no' }
      ]}
    >
      <link rel="canonical" href={makePaginationUrl(canonicalUrl, currentPage)} />
    </Helmet>
  );
}
